import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'point', 'IconPoint', [["path",{"d":"M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-0"}]]);